module.exports = "/_next/static/images/aeccde967e75a84626db44a90b9eee03-derechos-arco-icon.svg";